import { Lists } from 'types'

const SetCurrentProductReducer = (state: Lists, action: { payload: string }) => {
  const orderbook = state.orderbooks![action.payload]
  const { products } = orderbook

  switch (orderbook.current) {
    case products[0]:
      state.orderbooks![action.payload].current = products[1]
      break;
    case products[1]:
      state.orderbooks![action.payload].current = products[2]
      break;
    case products[2]:
      state.orderbooks![action.payload].current = products[0]
      break;
    default:
  }
}

export default SetCurrentProductReducer
